import React from 'react';
import { render } from 'react-dom';

import globalAssign from 'js/utils/assign_global';

import Responsive from 'js/courses/shared/Responsive';
import LoggedOutPage, {
  Props as LoggedOutPageProps,
} from 'js/courses/discovery/LoggedOutDiscoveryPage';
import LoggedInPage, {
  Props as LoggedInPageProps,
} from 'js/courses/discovery/LoggedInDiscoveryPage';

import TopicMarketingPage, {
  Props as TopicMarketingPageProps,
} from 'js/courses/topic/TopicMarketingPage';

function renderLoggedOutCoursesDiscoveryPage(
  elementId: string,
  props: LoggedOutPageProps,
) {
  render(
    <Responsive>
      <LoggedOutPage {...props} />
    </Responsive>,
    document.getElementById(elementId),
  );
}

function renderLoggedInCoursesDiscoveryPage(
  elementId: string,
  props: LoggedInPageProps,
) {
  render(
    <Responsive>
      <LoggedInPage {...props} />
    </Responsive>,
    document.getElementById(elementId),
  );
}

function renderTopicMarketingPage(
  elementId: string,
  props: TopicMarketingPageProps,
) {
  render(<TopicMarketingPage {...props} />, document.getElementById(elementId));
}

globalAssign('Aedu.CoursesDiscovery', {
  renderLoggedOutCoursesDiscoveryPage: renderLoggedOutCoursesDiscoveryPage,
  renderLoggedInCoursesDiscoveryPage: renderLoggedInCoursesDiscoveryPage,
  renderTopicMarketingPage: renderTopicMarketingPage,
});
